import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import MainPhoto from '@pages/home/dogs/MainPhoto';
import { Infobox } from '@pages/home/dogs/Infobox';
import { Advantages } from '@pages/home/dogs/Advantages';
import { TextBox } from '@pages/home/dogs/TextBox';
import { Veterinary } from '@pages/home/dogs/Veterinary';
import SocialMedia from '@components/social-media/SocialMedia';



const Dogs = () => {
	const { t } = useTranslation('web');

	return (
		<div className='home-content dogs-page'>
			
			<MainPhoto />

			<Infobox />

			<Advantages />

			<TextBox />

			<Veterinary />

			<div className='order-button-box'>
				<Link to={NavigateRoutesEnum.order} className='app-main-button disable-selection'>
					{t('shared.orderLongUpper')}
				</Link>
			</div>

			<SocialMedia />

		</div>
	);
};

export default Dogs;